import { Button } from "@mui/material"

export default function ButtonSeeker({ startIcon = null, endIcon = null, children, ...props }) {
    return (
        <Button startIcon={startIcon} endIcon={endIcon} {...props}>
            {children}
        </Button>
    )
}
